'use client'

import useEnquiry from '@hooks/useEnquiry'
import classNames from 'classnames'
import { useCallback } from 'react'
import { useBoolean } from 'react-use'
import DisablePrefetchLink from '@component/disablePrefetchLink'
import { isFunction } from 'lodash-es'
import { enquiryDataLayer } from '@plugin/google/gtm/modules/property'
import { agentCardDataLayer } from '@plugin/google/gtm/modules/agent'

export default function AgentEmailButton({
  data,
  house,
  className,
  icon = false,
  full = true,
  sendAllAgent = false,
  onClick,
  children
}) {

  const { showAgentEnquiry, showHouseEnquiry } = useEnquiry()
  const clickHandle = useCallback(event => {
    isFunction(onClick) && onClick()
    if (data) agentCardDataLayer.emailClick(data)
    if (house) {
      showHouseEnquiry({ house, agent: data, sendAllAgent, signupSource: 'agent_enquiry' })(event)
    } else {
      showAgentEnquiry({ agent: data, signupSource: 'agent_appraisal' })(event)
    }
  }, [showAgentEnquiry, showHouseEnquiry, house, onClick, data, sendAllAgent])

  return (
    <button
      type='button'
      className={classNames(
        'button-orange',
        { 'w-full': full },
        { 'px-20 justify-between': icon },
        className
      )}
      onClick={clickHandle}
      aria-label='get an appraisal'
      data-noprogress
    >
      {icon && <i className='icon icon-email'></i>}
      <span className={classNames('pointer-events-none', { 'flex-1 text-center': icon })}>{children || 'Email'}</span>
    </button>
  )
}

export function VillageEmailButton({
  email,
  full = false,
  icon = false,
  className
}) {


  const [displayEmail, toggleEmail] = useBoolean(false)
  const showEmail = useCallback(() => {
    enquiryDataLayer.click()
    toggleEmail(true)
  }, [toggleEmail])

  return email && (
    <DisablePrefetchLink
      href={`mailto:${email}`}
      className={classNames(
        'button-primary-out',
        { 'w-full': full },
        { 'px-20 justify-between': icon },
        className
      )}
      onClick={showEmail}
      data-noprogress
    >
      {icon && <i className='icon icon-email'></i>}
      <span className={classNames({ 'flex-1 text-center': icon })}>{displayEmail ? email : 'Email'}</span>
    </DisablePrefetchLink>
  )
}